import { DEVICE_ROLES } from '@/features/core/container';
import { SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import lg from './lifting-station-lg.svg';
import md from './lifting-station-md.svg';
import sm from './lifting-station-sm.svg';
import component from './LiftingStationDevicePanel.vue';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.LIFTING_STATION,
  label: 'Abwasserhebeanlage',
  shortLabel: 'Wasser',
  icons: { sm, md, lg },
  component,
  defaultMetricNames: ['online'],
  importantMetricNames: ['online'],
}));
